import { FC, ReactNode } from 'react';

import clsx from 'clsx';

import styles from './InfoBanner.module.css';

export enum InfoBannerType {
  INFO = 'info',
  WARNING = 'warning',
  WAITING = 'waiting',
}

type InfoBannerProps = {
  message: ReactNode;
  className?: string;
  type?: InfoBannerType;
};

export const InfoBanner: FC<InfoBannerProps> = ({
  message,
  className = '',
  type = InfoBannerType.INFO,
}) => {
  const containerClass =
    type === InfoBannerType.INFO
      ? styles.infoContainer
      : type === InfoBannerType.WARNING
        ? styles.warningContainer
        : styles.waitingContainer;

  const contentClass =
    type === InfoBannerType.INFO
      ? styles.info
      : type === InfoBannerType.WARNING
        ? styles.warning
        : styles.waiting;

  return (
    <div className={clsx(containerClass, className)}>
      <div className={contentClass}>{message}</div>
    </div>
  );
};
